import api from '@/api'

const getCoupons = function (params={}) {
  return api.get(`/coupons`, {params})
}
const getCoupon = function (coupon_id) {
  return api.get(`/coupons/${coupon_id}`)
}
const getCompanyCoupons = function (org_id, params={}) {
  return api.get(`/organizations/${org_id}/coupons`,{params})
}
const getCouponItems = function (coupon_id, params={}) {
  return api.get(`/coupons/${coupon_id}/items`,{params})
}
const getCouponItemsServiceCode = function (coupon_id, service_code) {
  return api.get(`/coupons/${coupon_id}/items/${service_code}`)
}
const getCouponSchedules = function (coupon_id) {
  return api.get(`/coupons/${coupon_id}/schedules`)
}
const getCouponSchedule = function (coupon_id,schedule_id) {
  return api.get(`/coupons/${coupon_id}/schedules/${schedule_id}`)
}
const getCanCompanyUseCoupon = function (org_id) {
  return api.get(`/organizations/${org_id}/features/coupons`)

}
const putCouponItemsServiceCode = function (coupon_id, service_code) {
  return api.put(`/coupons/${coupon_id}/items/${service_code}`)
}
const putCanCompanyUseCoupon = function (org_id) {
  return api.put(`/organizations/${org_id}/features/coupons`)
}

const postCompanyCoupons = function (org_id, params) {
  return api.post(`/organizations/${org_id}/coupons`, params)
}
const patchCoupon = function (coupon_id, params) {
  return api.patch(`/coupons/${coupon_id}`, params)
}
const postCouponSchedules = function (coupon_id, params) {
  return api.post(`/coupons/${coupon_id}/schedules`, params)
}

const patchCouponItemsServiceCode = function (coupon_id, service_code, params) {
  // {
  //   "limit": 0
  // }
  return api.patch(`/coupons/${coupon_id}/items/${service_code}`, params)
}
const removeLimitCouponItemsServiceCode = function (coupon_id, service_code) {
  return api.post(`/coupons/${coupon_id}/items/${service_code}/remove-limit`, {})
}
const patchCouponSchedule = function (coupon_id,schedule_id,  params) {
  // {
  //   "start_time": "string",
  //   "end_time": "string",
  //   "discount": 0
  // }
  return api.patch(`/coupons/${coupon_id}/schedules/${schedule_id}`, params)
}

const deleteCoupon = function (coupon_id) {
  return api.delete(`/coupons/${coupon_id}`)
}
const deleteCouponItemsServiceCode = function (coupon_id, service_code) {
  return api.delete(`/coupons/${coupon_id}/items/${service_code}`)
}
const deleteCouponSchedule = function (coupon_id, schedule_id) {
  return api.delete(`/coupons/${coupon_id}/schedules/${schedule_id}`)
}
const deleteCanCompanyUseCoupon = function (org_id) {
  return api.delete(`/organizations/${org_id}/features/coupons`)
}


export default {
  getCoupons,
  getCoupon,
  getCompanyCoupons,
  getCouponItems,
  getCouponItemsServiceCode,
  getCouponSchedule,
  getCouponSchedules,
  getCanCompanyUseCoupon,

  putCouponItemsServiceCode,
  putCanCompanyUseCoupon,

  postCompanyCoupons,
  postCouponSchedules,

  patchCoupon,
  patchCouponItemsServiceCode,
  removeLimitCouponItemsServiceCode,
  patchCouponSchedule,

  deleteCoupon,
  deleteCouponItemsServiceCode,
  deleteCouponSchedule,
  deleteCanCompanyUseCoupon,
}
